// extracted by mini-css-extract-plugin
module.exports = {"video":"style_video__aqF3L","modal":"style_modal__Uw5Ij","modal-body":"style_modal-body__PDKZ5","modalBody":"style_modal-body__PDKZ5"};